import { render, staticRenderFns } from "./ViewTemplateModal.vue?vue&type=template&id=0b65b2f8&"
import script from "./ViewTemplateModal.vue?vue&type=script&lang=js&"
export * from "./ViewTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports